<div class="lib">

  <!-- ── Header ───────────────────────────────────────────────── -->
  <header class="lib__header">
    <div>
      <h1 class="lib__title">
        <i class="fa-solid fa-book-open lib__title-icon"></i>
        {{ 'LIBRARY.TEACHER_TITLE' | translate }}
      </h1>
      <p class="lib__subtitle">{{ 'LIBRARY.TEACHER_SUBTITLE' | translate }}</p>
    </div>
    <div class="lib__header-actions">
      <span class="lib__count">
        {{ 'LIBRARY.COUNT' | translate:{ count: filtered().length } }}
      </span>
      <button class="lib__btn-archived" type="button"
              [class.is-on]="showArchived()" (click)="toggleArchived()">
        <i class="fa-solid fa-box-archive"></i>
        {{ 'LIBRARY.SHOW_ARCHIVED' | translate }}
      </button>
      <button class="lib__btn-upload" type="button" (click)="openUpload()">
        <i class="fa-solid fa-cloud-arrow-up"></i>
        {{ 'LIBRARY.UPLOAD.BTN' | translate }}
      </button>
    </div>
  </header>

  <!-- ── Filters bar ──────────────────────────────────────────── -->
  <section class="lib__filters">
    <div class="lib__search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="search"
             [value]="query()"
             (input)="onQueryInput($any($event.target).value)"
             [placeholder]="'LIBRARY.SEARCH_PLACEHOLDER' | translate">
    </div>
  </section>

  <!-- Category chips -->
  <nav class="lib__chips">
    <button *ngFor="let f of categoryFilters"
            class="lib__chip" type="button"
            [class.is-active]="selectedCategory() === f.key"
            (click)="setCategory(f.key)">
      <i [class]="f.icon"></i>
      {{ f.i18nKey | translate }}
    </button>
  </nav>

  <!-- ── Loading skeleton ─────────────────────────────────────── -->
  <div *ngIf="loading()" class="lib__skeleton">
    <div class="lib__skel-row" *ngFor="let _ of [1,2,3]"></div>
  </div>

  <!-- ── Error state ──────────────────────────────────────────── -->
  <div *ngIf="!loading() && errored()" class="lib__error">
    <i class="fa-solid fa-triangle-exclamation"></i>
    {{ 'LIBRARY.LOAD_ERROR' | translate }}
  </div>

  <!-- ── Results ──────────────────────────────────────────────── -->
  <ng-container *ngIf="!loading() && !errored()">
    <div class="lib__list" *ngIf="filtered().length > 0; else emptyTpl">
      <div class="lib__item" *ngFor="let m of filtered()">
        <app-course-material-card
          [material]="m"
          (download)="onDownload($event)"
          (preview)="previewTarget.set($event)"
          (openExternal)="onOpenExternal($event)">
        </app-course-material-card>
        <div class="lib__item-actions">
          <!-- Un support archive ne se modifie ni ne se rearchive : il se
               remet en circulation, ou rien. -->
          @if (m.isArchived) {
            <button class="lib__act-btn lib__act-btn--restore" type="button"
                    (click)="unarchive(m)"
                    [title]="'LIBRARY.UNARCHIVE' | translate">
              <i class="fa-solid fa-box-open"></i>
            </button>
          } @else {
            <!-- Diffuser : c'est ici que la video d'une seance de production
                 devient visible des eleves. Elle nait privee. -->
            <button class="lib__act-btn"
                    [class.lib__act-btn--published]="m.isPublic"
                    type="button" (click)="togglePublished(m)"
                    [title]="(m.isPublic ? 'LIBRARY.UNPUBLISH' : 'LIBRARY.PUBLISH') | translate">
              <i class="fa-solid" [class.fa-eye]="m.isPublic" [class.fa-eye-slash]="!m.isPublic"></i>
            </button>
            <button class="lib__act-btn lib__act-btn--edit" type="button" (click)="openEdit(m)">
              <i class="fa-solid fa-pen"></i>
            </button>
            <button class="lib__act-btn lib__act-btn--del" type="button" (click)="openDelete(m)">
              <i class="fa-solid fa-archive"></i>
            </button>
          }
        </div>
      </div>
    </div>

    <ng-template #emptyTpl>
      <div class="lib__empty">
        <div class="lib__empty-icon"><i class="fa-solid fa-folder-open"></i></div>
        <h3>{{ 'LIBRARY.TEACHER_EMPTY_TITLE' | translate }}</h3>
        <p>{{ 'LIBRARY.TEACHER_EMPTY_DESC' | translate }}</p>
        <button class="lib__btn-upload lib__btn-upload--ghost" type="button" (click)="openUpload()">
          <i class="fa-solid fa-plus"></i>
          {{ 'LIBRARY.UPLOAD.BTN' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-container>

</div>

<!-- ════════════════════════════════════════════════════════════
     UPLOAD MODAL
════════════════════════════════════════════════════════════ -->
<dialog #uploadDialog class="lib-dialog"
        (close)="onUploadClosed()"
        (cancel)="onUploadCancel($event)"
        (mousedown)="onPressStart($event)"
        (click)="onBackdropClick($event, uploadDialog)">
  <form class="lib-modal" *ngIf="uploadOpen()" (ngSubmit)="submitUpload()">
    <header class="modal__head">
      <h2 class="modal__title">{{ 'LIBRARY.UPLOAD.TITLE' | translate }}</h2>
      <button class="modal__close" type="button" (click)="closeUpload()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <!-- L'erreur vit en tete du formulaire, pas en pied : en bas d'un corps
         defilant, elle n'apparaissait qu'apres avoir fait defiler, et le
         formulaire semblait ne rien repondre au clic sur « Publier ».
         `role="alert"` la fait annoncer par les lecteurs d'ecran. -->
    @if (uploadError()) {
      <p class="modal__error" role="alert">
        <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
        {{ uploadError()! | translate }}
      </p>
    }

    <div class="modal__body">

    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.TITLE' | translate }} *</label>
      <input type="text" [(ngModel)]="uploadForm.title" name="title" required>
    </div>

    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.DESCRIPTION' | translate }}</label>
      <textarea [(ngModel)]="uploadForm.description" name="description" rows="3"></textarea>
    </div>

    <!-- Le type de support n'est plus demandé : le serveur le déduit du
         fichier ou du lien. Rien n'empêchait auparavant de publier une vidéo
         sous « PDF », et c'est ce type qui pilote l'icône, le filtre et
         l'aperçu. -->
    <div class="form-row">
      <div class="form-field">
        <label>{{ 'LIBRARY.UPLOAD.FORM.LEARNING_PATH_ID' | translate }} *</label>
        <!-- 0 : rien de choisi (le libellé d'invite s'affiche). null : diffusion
             générale — règlement intérieur, note d'information… -->
        <app-searchable-select
          [options]="pathOptions" [value]="uploadForm.learningPathId ?? null"
          [placeholder]="'ADMIN.SELECT_PATH' | translate" icon="fa-solid fa-route"
          [allLabel]="'LIBRARY.UPLOAD.FORM.ALL_PATHS' | translate"
          (valueChange)="onUploadPathChange($event)">
        </app-searchable-select>
        <small class="form-hint">{{ 'LIBRARY.UPLOAD.FORM.ALL_PATHS_HINT' | translate }}</small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label>{{ 'LIBRARY.UPLOAD.FORM.SUBJECT_ID' | translate }}</label>
        <app-searchable-select
          [options]="subjectOptions" [value]="uploadForm.subjectId ?? null"
          placeholder="—" allLabel="—" icon="fa-solid fa-book"
          [disabled]="!uploadForm.learningPathId"
          [title]="!uploadForm.learningPathId ? ('LIBRARY.UPLOAD.FORM.ALL_PATHS_HINT' | translate) : ''"
          (valueChange)="onUploadSubjectChange($event)">
        </app-searchable-select>
      </div>
      <div class="form-field">
        <label>{{ 'LIBRARY.UPLOAD.FORM.THEME_ID' | translate }}</label>
        <app-searchable-select
          [options]="themeOptions" [value]="uploadForm.themeId ?? null"
          placeholder="—" allLabel="—" icon="fa-solid fa-layer-group"
          [disabled]="!uploadForm.subjectId"
          (valueChange)="uploadForm.themeId = $event">
        </app-searchable-select>
      </div>
    </div>

    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.EXTERNAL_URL' | translate }}</label>
      <input type="url" [(ngModel)]="uploadForm.externalUrl" name="externalUrl"
             placeholder="https://...">
    </div>

    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.FILE' | translate }}</label>
      <input type="file" (change)="onFileChange($event)" class="form-file">
      <span class="form-hint" *ngIf="selectedFile">{{ selectedFile.name }}</span>
      <span class="form-hint">{{ 'LIBRARY.UPLOAD.FORM.SIZE_LIMIT' | translate }}</span>
    </div>

    <!-- Un fichier lourd part directement vers le stockage : sans barre, le
         professeur ne saurait pas si l'envoi avance ou s'il est bloqué. -->
    <div class="lib-progress" *ngIf="uploadPercent() !== null">
      <progress class="lib-progress__bar" max="100" [value]="uploadPercent()"
                [attr.aria-label]="'LIBRARY.UPLOAD.SUBMIT' | translate"></progress>
      <span class="lib-progress__pct">{{ uploadPercent() }}%</span>
    </div>

    <label class="form-check">
      <input type="checkbox" [(ngModel)]="uploadForm.isPublic" name="isPublic">
      {{ 'LIBRARY.UPLOAD.FORM.IS_PUBLIC' | translate }}
    </label>

    </div>

    <footer class="modal__foot">
      <button type="button" class="btn-secondary" (click)="closeUpload()" [disabled]="uploading()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="submit" class="btn-primary" [disabled]="uploading()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="uploading()"></i>
        {{ 'LIBRARY.UPLOAD.SUBMIT' | translate }}
      </button>
    </footer>
  </form>
</dialog>

<!-- ════════════════════════════════════════════════════════════
     EDIT MODAL
════════════════════════════════════════════════════════════ -->
<dialog #editDialog class="lib-dialog"
        (close)="onEditClosed()"
        (mousedown)="onPressStart($event)"
        (click)="onBackdropClick($event, editDialog)">
  <form class="lib-modal" *ngIf="editOpen()" (ngSubmit)="submitEdit()">
    <header class="modal__head">
      <h2 class="modal__title">{{ 'LIBRARY.EDIT.TITLE' | translate }}</h2>
      <button class="modal__close" type="button" (click)="closeEdit()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <div class="modal__body">
    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.TITLE' | translate }} *</label>
      <input type="text" [(ngModel)]="editForm.title" name="title" required>
    </div>
    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.DESCRIPTION' | translate }}</label>
      <textarea [(ngModel)]="editForm.description" name="description" rows="3"></textarea>
    </div>
    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.EXTERNAL_URL' | translate }}</label>
      <input type="url" [(ngModel)]="editForm.externalUrl" name="externalUrl">
    </div>
    <label class="form-check">
      <input type="checkbox" [(ngModel)]="editForm.isPublic" name="isPublic">
      {{ 'LIBRARY.UPLOAD.FORM.IS_PUBLIC' | translate }}
    </label>

    </div>

    <footer class="modal__foot">
      <button type="button" class="btn-secondary" (click)="closeEdit()" [disabled]="saving()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="submit" class="btn-primary" [disabled]="saving()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="saving()"></i>
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </footer>
  </form>
</dialog>

<!-- ════════════════════════════════════════════════════════════
     DELETE CONFIRM
════════════════════════════════════════════════════════════ -->
<dialog #deleteDialog class="lib-dialog"
        (close)="onDeleteClosed()"
        (mousedown)="onPressStart($event)"
        (click)="onBackdropClick($event, deleteDialog)">
  <div class="lib-modal lib-modal--sm" *ngIf="deleteTarget()">
    <header class="modal__head">
      <h2 class="modal__title">{{ 'LIBRARY.ARCHIVE.TITLE' | translate }}</h2>
    </header>
    <div class="modal__body">
      <p>{{ 'LIBRARY.ARCHIVE.CONFIRM' | translate:{ title: deleteTarget()!.title } }}</p>
    </div>
    <footer class="modal__foot">
      <button type="button" class="btn-secondary" (click)="cancelDelete()" [disabled]="deleting()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn-danger" (click)="confirmDelete()" [disabled]="deleting()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="deleting()"></i>
        {{ 'LIBRARY.ARCHIVE.BTN' | translate }}
      </button>
    </footer>
  </div>
</dialog>
<!-- Aperçu : le flux passe par l'endpoint professeur, qui exige le jeton. -->
<app-material-preview
  [material]="previewTarget()"
  [download]="downloadFn"
  (closed)="previewTarget.set(null)"></app-material-preview>
